import { Helmet } from "react-helmet-async";

const SITE_NAME = "Fiable ou Pas";
const SITE_DESCRIPTION =
  "Vérifiez la fiabilité d'un site marchand avant d'acheter. Score de risque, signaux de vigilance et recommandations en quelques secondes.";
const ORIGIN =
  process.env.REACT_APP_PUBLIC_SITE_URL ||
  process.env.REACT_APP_BACKEND_URL ||
  (typeof window !== "undefined" ? window.location.origin : "");
const API_ORIGIN =
  process.env.REACT_APP_BACKEND_URL ||
  (typeof window !== "undefined" ? window.location.origin : "");

const DEFAULT_OG_IMAGE = null; // og:image invariant servi via index.html

/**
 * Composant SEO réutilisable.
 * - title, description, canonical (path), image, type
 * - noindex pour les pages dynamiques type /analyse/:domain
 * - jsonLd pour balises structurées (objet ou tableau)
 */
export default function Seo({
  title,
  description = SITE_DESCRIPTION,
  path = "",
  image = DEFAULT_OG_IMAGE,
  type = "website",
  noindex = false,
  jsonLd = null,
  keywords = null,
}) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Vérifiez. Comprenez. Décidez sereinement.`;
  const url = ORIGIN + path;
  const ldArray = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet>
      <html lang="fr" />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />

      {/* Open Graph (site_name/locale gérés en static dans index.html) */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}
      {image && <meta property="og:image:width" content="1200" />}
      {image && <meta property="og:image:height" content="630" />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}

      {ldArray.map((ld, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(ld)}
        </script>
      ))}
    </Helmet>
  );
}

export { SITE_NAME, SITE_DESCRIPTION, ORIGIN, API_ORIGIN };
